import React from "react";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../constants/site";
import { sponsors } from "../data/sponsors";

export default function Footer() {
    return (
        <footer className="bg-gray-800 border-t border-sky-400/20">
            <div className="container mx-auto px-4 py-8">
                <div className="text-center ">
                    <h3 className="text-xl font-bold text-sky-400 mb-4">Osprey Racing</h3>
                    <div className="flex flex-wrap justify-center items-center gap-6 mb-4">
                        {sponsors.map((sponsor) => (
                            <a
                                key={sponsor.id}
                                href={sponsor.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={sponsor.logo}
                                    alt={sponsor.name}
                                    className="h-10 w-auto object-contain"
                                />
                            </a>
                        ))}
                    </div>
                    <p className="text-transparent bg-clip-text bg-gradient-to-r from-sky-400 via-yellow-400 to-sky-400 mb-2 font-semibold">Race. Ride. Volunteer.</p>
                    <p className="text-transparent bg-clip-text bg-gradient-to-r from-gray-400 via-pink-400 to-gray-400 text-sm">Fostering community through cycling</p>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block text-transparent bg-clip-text bg-gradient-to-r from-sky-400 to-yellow-400 hover:from-yellow-400 hover:to-sky-400 transition-all duration-300 font-semibold"
                    >
                        {INSTAGRAM_HANDLE}
                    </a>
                    <p className="text-gray-400 text-sm">
                        © {new Date().getFullYear()} Good Harp, Worth It Productions. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
